<template>
  <div class="pk-record">
    <el-dialog
      :title="dialogTitle"
      :visible="true"
      width="80%"
      :before-close="handleClose"
    >
      <div class="today" v-if="Object.keys(toDayPkData).length > 0">
        <div>
          <el-button type="primary" size="small">今日</el-button>
        </div>
        <div class="content">
          <div class="team-grade">
            {{ translationDan(toDayPkData.grade) }}段位
          </div>
          <div class="team-pk-info">
            <div class="team-a">
              <div>{{ toDayPkData.seasonTeamAName }}</div>
              <div>{{ toDayPkData.seasonTeamAAchievement }}</div>
            </div>
            <div class="vs">VS</div>
            <div class="team-b">
              <div>{{ toDayPkData.seasonTeamBName }}</div>
              <div>{{ toDayPkData.seasonTeamBAchievement }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="history">
        <div>
          <el-button type="primary" size="small">历史记录</el-button>
        </div>
        <div class="content">
          <div class="control">
            <span>PK战队名称：</span>
            <div>
              <el-input
                size="small"
                type="text"
                v-model="teamName"
                placeholder="请输入战队名称"
              ></el-input>
            </div>
            <span>输入赛季：</span>
            <div>
              <el-select
                size="small"
                v-model="seasonId"
                placeholder="请选择赛季"
              >
                <el-option
                  v-for="item in seasonList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div>
              <el-date-picker
                size="small"
                v-model="seasonCycle"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              >
              </el-date-picker>
            </div>
            <el-button size="small" type="primary" @click="handleSearch">
              查询
            </el-button>
            <el-button size="small" @click="handleReset">清空</el-button>
          </div>

          <div class="table">
            <el-table
              :data="historyPkList"
              style="width: 100%"
              :border="true"
              v-loading="historyLoading"
              row-key="id"
            >
              <el-table-column
                v-for="item in tableColumn"
                :key="item.prop"
                :prop="item.prop"
                :label="item.label"
                align="center"
                :min-width="item.width || '100'"
              >
                <template slot-scope="scope">
                  {{ tableTranslation(item.prop, scope.row) }}
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="pagination">
            <el-pagination
              @size-change="handleLimitChange"
              @current-change="handlePageChange"
              :current-page="page"
              :page-sizes="[10, 20, 30, 50]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import * as API from "@/api/season";
import dayjs from "dayjs";
import { translationDan, historyPkColumn } from "./assets";

export default {
  props: ["handleClose", "defaultData"],
  data() {
    const { name, pkName } = this.defaultData;
    return {
      dialogTitle: `${name ?? ""} (今日PK战队：${pkName ?? ""}) `,
      total: 0,
      page: 1,
      limit: 10,
      toDayPkData: {},
      historyPkList: [],
      historyLoading: false,
      teamName: null,
      seasonId: null,
      seasonCycle: null,
      seasonList: [],
      tableColumn: historyPkColumn,
    };
  },
  created() {
    this.getToDayPkInfo();
    this.getSeasonList();
    this.getHistoryPkList();
  },
  methods: {
    translationDan,
    async getSeasonList() {
      const params = {
        page: 1,
        limit: -1,
      };
      try {
        const res = await API.getSeasonList(params);
        const { code, data } = res;
        if (code === 0 && data) {
          const { records = [] } = data;
          const nextDataSource = records.map((item) => {
            const { name, id } = item;
            return {
              label: name,
              value: id,
            };
          });
          this.seasonList = nextDataSource;
        }
      } catch (error) {
        //防止request返回reject
      }
    },
    async getToDayPkInfo() {
      try {
        const { id: teamId } = this.defaultData;
        const params = {
          limit: 1,
          page: 1,
          teamId,
          startDate: dayjs().format("YYYY-MM-DD"),
          endDate: dayjs().format("YYYY-MM-DD"),
        };
        const res = await API.getCurrentTeamPkInfo(params);
        const { code, data } = res;
        if (code === 0 && data) {
          const { records = [] } = data;
          if (records[0]) {
            this.toDayPkData = records[0];
          }
        }
      } catch (error) {
        //防止request返回reject
      }
    },
    async getHistoryPkList() {
      this.historyLoading = true;
      try {
        const { page, limit, teamName, seasonId, seasonCycle } = this;
        const { id } = this.defaultData;
        const [startDate, endDate] = (seasonCycle ?? []).map((item) =>
          dayjs(item).format("YYYY-MM-DD")
        );
        const params = {
          page,
          limit,
          teamId: id,
          teamName,
          seasonId,
          startDate,
          endDate,
        };
        const res = await API.getCurrentTeamPkInfo(params);
        const { code, data } = res;
        if (code === 0 && data) {
          const { total, records = [] } = data;
          this.historyPkList = records ?? [];
          this.total = Number(total);
        }
      } catch (error) {
        //防止request返回reject
      } finally {
        this.historyLoading = false;
      }
    },
    handleSearch() {
      this.page = 1;
      this.getHistoryPkList();
    },
    handleReset() {
      this.teamName = null;
      this.seasonId = null;
      this.seasonCycle = null;
      this.page = 1;
      this.getHistoryPkList();
    },
    handleLimitChange(limit) {
      this.limit = limit;
      this.page = 1;
      this.getHistoryPkList();
    },
    handlePageChange(page) {
      this.page = page;
      this.getHistoryPkList();
    },
    tableTranslation(prop, rowData) {
      const { victoryTeamId, grade, seasonTeamBName, seasonTeamAId } = rowData;
      switch (prop) {
        case "grade":
          return translationDan(grade);
        case "seasonTeamBNameAndGrade":
          return `${seasonTeamBName}/${translationDan(grade)}`;
        case "isVictory":
          return victoryTeamId === seasonTeamAId ? "胜利" : "失败";
        default:
          return rowData[prop];
      }
    },
  },
};
</script>
<style scoped lang="scss">
.pk-record {
  .today {
    .content {
      border-radius: 4px;
      border: 1px solid rgba(187, 187, 187, 100);
      display: inline-block;
      padding: 10px;
      margin: 20px 0;
      .team-grade {
        color: rgba(16, 16, 16, 100);
        font-size: 14px;
        margin-bottom: 20px;
        font-weight: 700;
      }
      .team-pk-info {
        display: flex;
        align-items: center;
        font-weight: 700;
        text-align: center;
        .team-a,
        .team-b {
          padding: 0 50px;
          > div:first-child {
            color: rgba(16, 16, 16, 100);
            font-size: 20px;
            margin-bottom: 20px;
          }
          > div:last-child {
            color: rgba(148, 253, 39, 100);
            font-size: 20px;
          }
        }
        .vs {
          color: rgba(16, 16, 16, 100);
          font-size: 20px;
          align-self: flex-start;
        }
      }
    }
  }
  .history {
    .content {
      margin: 20px 0;
      .control {
        display: flex;
        align-items: center;
        > div {
          margin-right: 20px;
        }
      }
      .table {
        margin: 20px 0;
      }
    }
  }
}
</style>
